import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Energy Management',
  path: '/homenet/ems',
  redirect: '/homenet/ems/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Info',
      'path': 'info',
      'meta': {
        'label': 'Info'
      },
      'component': lazyLoading('homenet/EMS')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/ems.js